import React, { forwardRef } from 'react';

import { Link } from 'react-resource-router';

import { type LinkItemProps } from './types';

export const LinkItem = forwardRef<HTMLAnchorElement, LinkItemProps>(
	(props: LinkItemProps, ref) => {
		const { children, onClick, ...rest } = props;
		return (
			<Link ref={ref} {...rest} onClick={onClick as any}>
				{children}
			</Link>
		);
	},
);
